import React from 'react';
import Footer from './Footer';
import ra1 from "../assets/images/reiki-stories.png";
import ra2 from "../assets/images/reiki-seminars.png";
import ra3 from "../assets/images/reiki-healing.png";
import ms from "../assets/images/default-avatar.png";
import bg from "../assets/images/BG.jpg";
import bb from "../assets/images/BB.jpg";
import { NavLink } from 'react-router-dom';

const Reiki = () => {
    return (
        <>
            <div className="page-header-reiki section-dark">
                <div className="filter"></div>
                <div className="content-center">
                    <div className="col col-md-10 mx-auto">
                        <div className="reiki-header-content">
                            <div className="title-brand">
                                <h1 className="text-warning">What is Reiki</h1><br />
                            </div>
                            <p className="text-light text-center">
                                <strong>Reiki</strong> is a form of alternative healing technique which is also referred to as <strong>energy healing</strong>.
                                Reiki has it's roots in Japanese origin. It is administered by either "touch or non-touch (distance)" as the <i>"universal life force energy"</i> flows through everything.
                                The word <strong>Reiki</strong> is made of two Japanese words - Rei which means <i>"God's Wisdom or the Higher Power or the Supreme Universe"</i> and Ki which is <i>"life force energy"</i>.
                                Therefore, the meaning of Reiki can simply be understood as the <i>"Universal Life Force Energy"</i>.
                            </p>
                            <p className="text-light text-center">
                                A Reiki session can help in releasing tension and stress and can treat one on all levels – physical, mental, and emotional, without any side-effect.
                                A session is very pleasant and relaxing and powerfull enough to heal one's <strong>body, mind and spirit</strong> all together.
                                It is a simple, natural and safe method of allround healing for oneself as well as others that everyone can use, irrespective of age, sex, place or time.
                            </p>
                            <p className="text-light text-center">
                                <strong>Dr. Mikao Usui</strong> is the founder of the Reiki system of natural healing.
                                Although it's not associated with any specific religion or culture, it is recommended to practice certain simple ethical ideals for the universal welbeing.
                            </p>
                            <p className="text-light text-center">
                                Reiki is very easy to learn. In fact, the ability to use Reiki is not taught in the usual sense, but the energy is transferred to the student (channel) during a process called <strong>"attunement"</strong>.
                                An "attunement" is given by a Reiki master and allows the student (channel) to tap into an unlimited supply of "universal life force energy".
                                It's use is not dependent on one's intellectual capacity or spiritual development and therefore is available to everyone. Thousands of people of all ages and backgrounds have received "attunement" so far.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <section id="portfolio">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-8 mx-auto">
                            <div className="p-0">
                                <div id="carouselCaptions" className="carousel slide" data-ride="carousel">
                                    <ol className="carousel-indicators">
                                        <li data-target="#carouselCaptions" data-slide-to="0" className="active"></li>
                                        <li data-target="#carouselCaptions" data-slide-to="1"></li>
                                        <li data-target="#carouselCaptions" data-slide-to="2"></li>
                                    </ol>
                                    <div className="carousel-inner carousel-box">
                                        <div className="carousel-item active">
                                            <img src={ra1} className="d-block w-100 carousel-image" alt="Aahok" />
                                            <div className="carousel-caption d-none d-md-block">
                                                <h5 className="text-dark">Reiki Stories</h5>
                                                <h6 className="text-warning">We publish various articles and stories of people</h6>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src={ra2} className="d-block w-100 carousel-image" alt="Youtube" />
                                            <div className="carousel-caption d-none d-md-block">
                                                <h5 className="text-dark">Reiki Seminars</h5>
                                                <h6 className="text-warning">We arrange discussion sessions / seminars time to time</h6>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src={ra3} className="d-block w-100 carousel-image" alt="Reiki" />
                                            <div className="carousel-caption d-none d-md-block">
                                                <h5 className="text-dark">Reiki Healing</h5>
                                                <h6 className="text-warning">We offer reiki sessions for the people who requests</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselCaptions" role="button" data-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselCaptions" role="button" data-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="reiki-stories" className="testimonials-clean">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-10 mx-auto">
                            <h2 className="text-dark">Featured Stories</h2>
                        </div>
                    </div>
                    <div className="row people">
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <h4>My experiences with Reiki</h4>
                                <p className="description"><NavLink to="/reiki/story1" exact>Read now</NavLink><br /></p>
                            </div>
                            <div className="author">
                                <img className="rounded-circle" src={bb} alt="Author" />
                                <h5 className="name">Bishaljyoti Bora</h5>
                                <p className="title">Reiki Second Degree</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <h4>Reiki in your daily life</h4>
                                <p className="description"><NavLink to="/reiki/story2" exact>Read now</NavLink><br /></p>
                            </div>
                            <div className="author">
                                <img className="rounded-circle" src={bg} alt="Author" />
                                <h5 className="name">Bimal Goswami</h5>
                                <p className="title">Reiki Second Degree</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <div className="box">
                                <h4>Basics of Reiki</h4>
                                <p className="description"><NavLink to="/reiki/story3" exact>Read now</NavLink><br /></p>
                            </div>
                            <div className="author">
                                <img className="rounded-circle" src={bg} alt="Author" />
                                <h5 className="name">Bimal Goswami</h5>
                                <p className="title">Reiki Second Degree</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-md-10 mx-auto">
                            <NavLink className="btn btn-outline-success js-scroll-trigger" role="button" to="/p404">All Stories!</NavLink>
                        </div>
                    </div>
                </div>
            </section>
            <section id="team" className="team-clean">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-12 text-center">
                            <h2 className="text-dark">Our Healers</h2>
                            <hr className="my-4 mx-auto" />
                        </div>
                    </div>
                    <div className="row people">
                        <div className="col-md-6 col-lg-4 item">
                            <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" src={bb} alt="Bishal" />
                            <h3 className="name">Bishaljyoti Bora<br /></h3>
                            <p className="title">Reiki Second Degree</p>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" data-aos-delay="250" src={bg} alt="Bimal" />
                            <h3 className="name">Bimal Goswami<br /></h3>
                            <p className="title">Reiki Second Degree</p>
                        </div>
                        <div className="col-md-6 col-lg-4 item">
                            <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" data-aos-delay="500" src={ms} alt="Moon" />
                            <h3 className="name">Moonjyoti Saikia<br /></h3>
                            <p className="title">Reiki Second Degree</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="aboutus" className="bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col col-md-10 mx-auto">
                            <h2 className="text-dark">Let us help you<br/></h2>
                            <hr className="my-4 mx-auto" />
                            <p className="text-faded mb-4">
                                You can get the benefit of reiki in every aspect of your life.
                                We have a group of reiki practitioners associated with us from First Degree holders to Grand Masters who are trying to make this planet a better one.<br/>
                            </p>
                            <NavLink className="btn btn-warning btn-xl" to="/email" exact>Contact Us!</NavLink>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Reiki;
